<div #hybridizerContainer>
  <div class="container-fluid unhide">
    <ui-view name="mainContent"></ui-view>
  </div>
</div>

<router-outlet></router-outlet>
